import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {getCities} from "models/cities"; // Importing getCities function from cities model
import {getTags} from "models/tags"; // Importing getTags function from tags model
import {getPositions} from "models/positions"; // Importing getPositions function from positions model
import "webix/photo"; // Importing webix photo module
import "webix/tinymce/tinymce"; // Importing TinyMCE editor from webix
import {devConfig} from "../../../config/config"; // Importing development configuration

/**
 * Class representing the search agent view.
 * @extends JetView
 */
export default class searchAgentView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service
        const screen = this.app.config.size; // Current screen size
        const cur_user = this.getParam("user", true); // Get current user parameter

        // If current user is defined, fetch agent data
        if(cur_user!=undefined){
          const vthis = this; // Preserve context for callbacks
          webix.ajax().get(devConfig.geturlApi() + "/Agent/GetAgentById", 'id=' + cur_user , {
              error: function (text, data, XmlHttpRequest) {
                  webix.message(_("Error! ")); // Show error message on failure
              },
              success: function (text, data, XmlHttpRequest) {
                  var json = JSON.parse(text); // Parse JSON response
                  if(!json.HasError){
                      vthis.app.callEvent("agentForm:data", [json.data]); // Trigger event with agent data
                      $$("formPagoPremio").show(); // Show payment form
                      $$("formPago").show(); // Show payment form
                      $$("back-button").show(); // Show back button
                      $$("consult-section").hide(); // Hide consultation section
                  }else{
                    webix.message({title: _("¡Error!"), type:"alert-error", text: _("Usuario no encontrado")}); // Show user not found error
                  }
              }
          });
        }

        // Configuration for the left section of the UI
        const left = {
            margin: 5,
            rows: [{
                margin: 15,
                css: "on-row",
                cols:[
                {
                    view: "combo", id: "nombre", // Combo box for user name
                    label: "<span class='icon-user'></span>" + _("Nombre del usuario"),
                    labelPosition:"top",
                    container:"cmb",
                    options:{
                        body:{
                            dataFeed: function (text) { // Data feed for combo box
                                this.parse(webix.ajax(devConfig.geturlApi() + "Agent/SearchAgentBalance?filter=" + text));
                            }
                        }
                    }
                },
                    {
                        view: "text", id: "idUser", // Text input for user ID
                        label: "<span class='icon-id'></span>" + _("ID del usuario"),
                        labelPosition: "top",
                        pattern: {mask: "##########", allow: /[0-9]/g}, // Input mask for numeric ID
                    },
                    { id: "grav2", gravity:2 } // Gravity for layout
                ]}
            ]
        };

        // Configuration for the upper section of the UI
        const upper_section = {
             css: "father-container",
            rows: [{
                margin: 10,
                cols: [
                    left, // Include the left section
                ]
            }]
        };

        // Sample data for payment information
        const datos = {
            ValorPagar: "1.2426", // Amount to pay
            ValorApostado: "1.00", // Amount bet
            PremioProyectado: "1.24", // Projected prize
            Estado: "Ganador", // Status
            Ganador: "Si" // Winner status
        };

        // Configuration for buttons section
        const buttons = {
            id:"b2",
                rows:[{
                    margin:10,
                    responsive: "b2",
                    cols:[
                    { id: "grav", gravity:4}, // Gravity for layout
                    { id:"aceptar2" }, // Placeholder for second accept button
                    {
                        view: "button", value: _("Continuar"), id:"aceptar", type: "form", width: (screen == "small") ? 0 : 130, minWidth: 200, // Continue button
                        click: () => {
                            let selectedId = $$("idUser").getValue().trim(); // Get trimmed user ID
                            let selectedName = $$("nombre").getValue(); // Get selected name
                            if (selectedId || selectedName) { // If either ID or name is provided
                                const vthis = this; // Preserve context for callbacks
                                webix.ajax().get(devConfig.geturlApi() + "/Agent/GetAgentById", 'id=' + (selectedId || selectedName) , {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message(_("Error! ")); // Show error message on failure
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text); // Parse JSON response
                                        if(!json.HasError){
                                            vthis.app.callEvent("agentForm:data", [json.data]); // Trigger event with agent data
                                            $$("formPagoPremio").show(); // Show payment form
                                            $$("formPago").show(); // Show payment form
                                            $$("back-button").show(); // Show back button
                                            $$("consult-section").hide(); // Hide consultation section
                                        }else{
                                          webix.message({title: _("¡Error!"), type:"alert-error", text: _("Usuario no encontrado")}); // Show user not found error
                                        }
                                    }
                                });
                            }
                        }
                    }]}
            ]
        };

        // Return the complete configuration for the form
        return {
            view: "form",
            id: "consult-section", // ID for the consultation section
            height:150, // Height of the form
            width: 0, // Width of the form
            rows: [
                upper_section, // Include upper section
                buttons // Include buttons section
            ]
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        $$("aceptar").hide(); // Hide continue button initially
        webix.ready(function(){
                if (screen.width < 500){ // Check screen width for responsive design
                    $$("grav").hide(); // Hide gravity element for small screens
                    $$("grav2").hide(); // Hide second gravity element for small screens
                }
            });
        $$("nombre").attachEvent("onChange", function(newv, oldv){ // Event listener for name combo box change
            if(newv >0){ // If new value is valid
                $$("aceptar").show(); // Show continue button
                $$("aceptar2").hide(); // Hide second accept button
            }
        });
        $$("idUser").attachEvent("onTimedKeyPress", function(){ // Event listener for user ID input
            if (this.getValue().length > 0){ // If input has value
                $$("aceptar").show(); // Show continue button
                $$("aceptar2").hide(); // Hide second accept button
            }
        });
        this.on(this.app, "TransferAgentSuccess", premio => { // Event listener for successful agent transfer
            this.getRoot().clear(); // Clear the form
            $$("aceptar").hide(); // Hide continue button
            $$("nombre").setValue(""); // Clear name input
            $$("idUser").setValue(""); // Clear user ID input
        });
    }
}

// FILE DOCUMENTED
